<template>
  <div class="iv-appra-declare-enroll">
    <section class="iv-main-width iv-p-t-40 iv-enroll-top iv-p-b-40">
      <Expand :defaultExpand="true">
        <h1 class="iv-fs-24 iv-fc-85" slot="title">{{declareInfo.applicationName}}</h1>
        <p class="iv-m-t-12 iv-fs-16 iv-fc-65">发布组织：{{declareInfo.publishOrgName}}</p>
        <Row class="iv-m-t-12">
          <Col :span="8" class="iv-fs-16 iv-fc-65">发布人：{{declareInfo.publisherName}}</Col>
          <Col :span="8" class="iv-fs-16 iv-fc-65">(发布人)邮箱：{{declareInfo.publisherEmail}}</Col>
          <Col :span="8" class="iv-fs-16 iv-fc-65">(发布人)联系方式：{{declareInfo.publisherContact}}</Col>
        </Row>
        <p class="iv-m-t-12 iv-fs-16 iv-fc-65 iv-enroll-top-description">
          <span>申报说明：</span>
          <span v-html="declareInfo.applicationExplain"></span>
        </p>
        <Expand class="iv-m-t-12 iv-fs-16 iv-fc-65" :showText="false">
          <template slot="title">
            <IconFont type="link" class="iv-m-r-8"></IconFont>
            <span>附件资料</span>
          </template>
          <Upload :readOnly="true" :isShowFileList="true" :multiple="true" :getUploadFiles="declareInfo.initalFile" class="iv-m-t-12"></Upload>
        </Expand>
      </Expand>
    </section>
    <div class="iv-p-t-40 iv-enroll-content">
      <div class="iv-main-width iv-p-b-40">
        <section class="iv-p-b-24">
          <h1 class="iv-fs-24 iv-fc-85 iv-vertical-line iv-m-b-16">包含奖项</h1>
          <ul class="iv-enroll-content-ul">
            <li
              @click="onSelectPrize(item, index)"
              class="iv-fs-16 iv-fc-65 iv-m-t-24 iv-pull-left iv-pointer" 
              :class="{'iv-enroll-active': index === currentIndex}" 
              v-for="(item, index) in prizeList" :key="index">
              <IconFont type="jiangli1" class="iv-m-r-12"></IconFont>{{item.objectName}}
            </li>
          </ul>
          <div class="iv-m-t-24 iv-enroll-content-desc">
            <p class="iv-fs-16 iv-fc-65">申报说明：{{prizeDesc}}</p>
            <Expand class="iv-m-t-12 iv-fs-16 iv-fc-65" :showText="false">
              <template slot="title">
                <IconFont type="link" class="iv-m-r-8"></IconFont>
                <span>附件资料</span>
              </template>
              <Upload :readOnly="true" :isShowFileList="true" :multiple="true" :getUploadFiles="prizeFiles" class="iv-m-t-12"></Upload>
            </Expand>
          </div>
        </section>
        <section>
          <div class="iv-app-detail-fill iv-m-b-20">
            <h1 class="iv-fs-24 iv-fc-85 iv-vertical-line">推荐信息</h1>
            <p class="iv-fs-16 iv-pointer iv-main-color"
              v-if="isSee && !readOnly && recommendInfo.isCancel != '1' && (basicFormType == 'JCBDLX01' || businessCode == 'BOE_REPORT_LIST_JCBDLX01')"
              @click="quickHandler">
              <IconFont type="xuanze" class="iv-m-r-12"></IconFont>从已报名中选择，快速填写
            </p>
          </div>
          <LayoutTitle :title="recommendFormList[0].displayName" v-if="recommendFormList.length">
            <FormLayout :readOnly="readOnly" :model="recommendInfo" :list="generatePage(0, 'recommendFormList')"></FormLayout>
          </LayoutTitle>
        </section>
        <section v-if="dynamicList.length">
          <Personal ref="Personal" :list="dynamicList" v-if="basicFormType == 'JCBDLX01' || businessCode == 'BOE_REPORT_LIST_JCBDLX01'" @on-request="getRecommendInfo" @on-close="closeLoading"></Personal>
          <Team ref="Personal" :list="dynamicList" v-if="basicFormType == 'JCBDLX02' || businessCode == 'BOE_REPORT_LIST_JCBDLX02'" @on-request="getRecommendInfo" @on-close="closeLoading"></Team>
          <Outside ref="Personal" :list="dynamicList" v-if="basicFormType == 'JCBDLX05' || businessCode == 'BOE_REPORT_LIST_JCBDLX05'" @on-request="getRecommendInfo" @on-close="closeLoading"></Outside>
          <Project ref="Personal" :list="dynamicList" v-if="basicFormType == 'JCBDLX04' || businessCode == 'BOE_REPORT_LIST_JCBDLX04'" @on-request="getRecommendInfo" @on-close="closeLoading"></Project>
          <Organization ref="Personal" :list="dynamicList" v-if="basicFormType == 'JCBDLX03' || businessCode == 'BOE_REPORT_LIST_JCBDLX03'" @on-request="getRecommendInfo" @on-close="closeLoading">
          </Organization>
        </section>
      </div>
    </div>
    <!-- 快速填写 -->
    <QuickModal ref="QuickModal"></QuickModal>
    <!-- 打分 -->
    <ScoreModal ref="ScoreModal" v-if="businessId"></ScoreModal>
    <FooterOperator>
      <div class="iv-text-center">
        <Button class="iv-m-r-8" type="save" @click="scoreHandler" v-if="businessId && score != 'result'">打分</Button>
        <span v-if="isSee && !isEnding">
          <span v-if="currentPrize.childReportTimeLimit" class="iv-m-r-16 iv-fs-16" style="color: #CD170A;">
            上报时限：{{timeFormat(currentPrize.childReportTimeLimit)}}
          </span>
          <Button 
            v-if="!readOnly && recommendInfo.isCancel == '0'" 
            :disabled="computedLimitTime(currentPrize.childReportTimeLimit, currentPrize.forceLimitTime)" 
            class="iv-m-r-8" 
            type="submit" 
            @click="submit"
          >提交报名</Button>
          <Button 
            v-if="!readOnly && recommendInfo.isCancel == '1'" 
            :disabled="computedLimitTime(currentPrize.childReportTimeLimit, currentPrize.forceLimitTime)" 
            class="iv-m-r-8" 
            type="cancel" 
            @click="cancel"
          >申请取消</Button>
        </span>
        <Button type="back" @click="back">返回</Button>
      </div>
    </FooterOperator>
    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { timeFormat } from '@/utils'
import Team from '../components/team'
import Upload from '@/components/upload'
import generateList from './recommend.js'
import Expand from '@/components/expand-info'
import Outside from '../components/outside'
import Project from '../components/project'
import IconFont from '@/components/iconfont'
import QuickModal from '../modal/index.vue'
import ScoreModal from '@/views/review/modal'
import Personal from '../components/personal'
import FormLayout from '@/components/layout/form'
import Organization from '../components/organization'
import FooterOperator from '@/components/footer-operator'
import LayoutTitle from '@/components/layout/layout-title'
import { getSignUpId } from '@/views/project-declare/sbgl-interface/index.js'
import { getMySignUpList, getApplication, getApplicationInfoId } from '../interface'

export default {
  data () {
    return {
      recommendInfo: {}, 
      declareInfo: {},
      prizeList: [],
      currentIndex: 0,
      prizeDesc: '',
      applicationObjectId: '',
      prizeFiles: [],
      signUpId: '',
      basicFormType: 'JCBDLX01', //显示哪种表单
      spinShow: false,
      isSee: false,
      dynamicFormId: '',
      dynamicList: [],
      currentPrize: {},
      isReadOnly: false,
      isEnding: false,
      isRecommend: false,
      recommendFormList: []
      // isCanel: null
    }
  },
  created () {
    const idMap = JSON.parse(sessionStorage.getItem('idMap'))
    const nameMap = JSON.parse(sessionStorage.getItem('nameMap'))
    //评审打分相关参数
    this.backUrl = this.$route.query.backUrl
    this.businessCode = this.$decode(this.$route.query.businessCode)
    this.businessId = this.$route.query.businessId || ''
    this.score = this.$decode(this.$route.query.score)
    this.objectId = this.$decode(this.$route.query.objectId)
    this.bizLineCode = this.$decode(this.$route.query.bizLineCode, 'YWX01')
    //本身的
    this.orgId = this.$decode(sessionStorage.getItem(idMap[this.bizLineCode]))
    this.orgName = this.$decode(sessionStorage.getItem(nameMap[this.bizLineCode]))
    this.readOnly = this.$decode(this.$route.query.type) == 'see'
    this.isEnding = this.$decode(this.$route.query.type) == 'see' || this.$route.query.isSignUp == true
    this.applicationInfoId = this.$decode(this.$route.query.applicationInfoId)
    this.setRecommendInfo()
    // this.recommendForm = recommendForm.call(this)
    //评审打分
    if (this.businessId) {
      this.basicFormType = ''
      this.typeMap = {
        'BOE_REPORT_LIST_JCBDLX01': 'JCBDLX01',
        'BOE_REPORT_LIST_JCBDLX02': 'JCBDLX02',
        'BOE_REPORT_LIST_JCBDLX03': 'JCBDLX03',
        'BOE_REPORT_LIST_JCBDLX04': 'JCBDLX04',
        'BOE_REPORT_LIST_JCBDLX05': 'JCBDLX05'
      }
      this.getBasicInfoForReview()
      //评优的逻辑会走
      this.getReviewSignUpId()
    } else {
      this.getDeclareBasicInfo()
    }
  },
  provide () {
    return {
      quickShowModal: this.quickShowModal,
      getApplicationObjectId: this.getApplicationObjectId
    }
  },
  methods: {
    timeFormat,
    //当前时间大于时限时间  按钮设置为禁用
    computedLimitTime (limitTime, forceLimitTime) {
      if (!limitTime || !forceLimitTime || forceLimitTime != 1) return false
      const currentTime = Date.now()
      return currentTime > limitTime + 86400000
    },
    //供子组件获取id  防止快速填写获取的id覆盖掉当前的
    getApplicationObjectId () {
      return this.applicationObjectId
    },
    //供快速填写使用
    quickShowModal (signUpId) {
      this.$nextTick(() => {
        let params = { signUpId: signUpId, orgId: this.orgId, readOnly:this.readOnly, quickFill: true }
        this.$refs.Personal.getPersonInfo(params)
      })
    },
    //快速填写弹框
    quickHandler () {
      this.$refs.QuickModal.open(this.currentPrize, this.bizLineCode)
    },
    //生成表单和表格
    generatePage (index, type) {
      return generateList.call(this, index, type)
    },
    //获取动态表单接口
    getDynamicFormInfo () {
      if (!this.dynamicFormId) return
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/dynamicform/form/getFormStructure',
          method: 'get',
          data: {
            formId: this.dynamicFormId,
            version: this.currentPrize.dynamicFormVersion
          }
        }).then(({data}) => {
          this.recommendFormList = []
          this.dynamicList = []
          const arr = data.data.formGroupList.filter(item => item.isEnabled == 1)
          arr.forEach((item) => {
            const codes = item.formPropertyList.map(val => val.propertyCode)
            //如果当前分组包含推荐单位和填表人  那么就认为他是推荐信息分组
            if (codes.includes('recommendOrgName') || codes.includes('fillInUserName')) {
              this.recommendFormList.push(item)
            } else {
              this.dynamicList.push(item)
            }
          })
          resolve()
        })
      })
    },
    // 点击申请取消按钮
    cancel() {
      if(this.basicFormType == 'JCBDLX01') { //个人
        this.applyCancelBtn('api-general/module/selection/personalCenter/signUp/appraising/cancelApprIndividualSignUp')
      } else if (this.basicFormType == 'JCBDLX02') { //团队
        this.applyCancelBtn('api-general/module/selection/personalCenter/signUp/appraising/cancelApprGroupSignUp')
      } else if (this.basicFormType == 'JCBDLX03') { //组织
        this.applyCancelBtn('api-general/module/selection/personalCenter/signUp/appraising/cancelApprOrgSignUp')
      } else if (this.basicFormType == 'JCBDLX04') { //项目
        this.applyCancelBtn('api-general/module/selection/personalCenter/signUp/appraising/cancelApprProjectSignUp')
      } else if (this.basicFormType == 'JCBDLX05') { //外部
        this.applyCancelBtn('api-general/module/selection/personalCenter/signUp/appraising/cancelApprExternalSignUp')
      }
    },
    //抽离申请取消按钮权限的接口
    applyCancelBtn (url) {
      this.$ajax({
        url: url,
        method: 'put',
        data: {
          signUpId: this.signUpId,
          orgId: this.orgId
        }
      }).then((data) => {
        this.$Message.success('取消成功')
        this.getCorreSignUpId()
      })
    },
    //内部存储推荐信息  防止修改
    setRecommendInfo () {
      this.recommendInfo = {
        signUpType: 'BMLX01',
        recommendOrgName: this.orgName,
        recommendOrgId: this.orgId,
        fillInUserName: this.$decode(sessionStorage.getItem('userName')),
        fillInUserId: this.$decode(sessionStorage.getItem('userId')),
        fillInUserEmail: this.$decode(sessionStorage.getItem('userEmail')),
        fillInUserPhone: this.$decode(sessionStorage.getItem('userPhone'))
      }
    },
    //评审打分  获取applicationId
    getBasicInfoForReview () {
      getApplicationInfoId({reportListId: this.businessId}).then(({data}) => {
        if (data && data.applicationInfoId) {
          this.applicationInfoId = data.applicationInfoId
          this.getDeclareBasicInfo(data.applicationObjectId)
        }
      })
    },
    //获取 评审打分查看的signUpId
    getReviewSignUpId () {
      if (!this.objectId) return
      getSignUpId ({listItemId: this.objectId}).then(async ({data}) => {
        if (!data.signUpId) return this.$Message.error('评审对象已改变，未找到该记录！')
        this.signUpId = data.signUpId
        this.dynamicFormId = data.dynamicFormId
        this.currentPrize['dynamicFormVersion'] = data.dynamicFormVersion
        //动态表单
        await this.getDynamicFormInfo()
        this.$nextTick(() => {
          let params = { signUpId: data.signUpId, orgId: this.orgId, readOnly:this.readOnly }
          this.$refs.Personal && this.$refs.Personal.getPersonInfo(data.signUpId ? params : null)
        })
      })
    },
    //评审打分
    scoreHandler () {
      this.$refs.ScoreModal.open()
    },
    //提交  调用子组件的提交方法
    submit () {
      this.spinShow = true
      let recommendInfoCopy = cloneDeep(this.recommendInfo)
      if (!this.recommendFormList.length) {
        recommendInfoCopy = {}
      }
      const params = { ...recommendInfoCopy, applicationObjectId: this.applicationObjectId, signUpId: this.signUpId }
      this.$refs.Personal.submitPersonInfo(params)
    },
    //提交时校验不通过 关闭loading
    closeLoading (status) {
      if (!status) {
        this.getCorreSignUpId() //修改
      }
      this.spinShow = false
    },
    //获取子组件派发的推荐信息
    getRecommendInfo (recommendInfo, type) {
      this.isSee = true
      this.spinShow = false
      this.isReadOnly = recommendInfo.isCancel == '1'
      if (recommendInfo.signUpId) {
        this.signUpId = recommendInfo.signUpId
        if (type == 'addType') { //修改
          this.getCorreSignUpId () //修改
        }
      }
      this.recommendInfo = Object.assign({}, this.recommendInfo, recommendInfo) 
    },
    //获取signUpId
    async getCorreSignUpId (type) {
      //动态表单
      await this.getDynamicFormInfo()
      getMySignUpList({applicationObjectId: this.applicationObjectId}).then(({data}) => {
        // this.isSee = true
        let params = {}
        if (data && data.length) {
          this.signUpId = data[0].signUpId
          // isReportState
          this.readOnly = !data[0].isReportState
          params = { signUpId: data[0].signUpId, orgId: this.orgId, isReportState:data[0].isReportState }
        } else {
          this.readOnly = false
          this.recommendInfo.isCancel = '0'
          this.isSee = true
        }
        this.$nextTick(() => {
          // if (type === 'check') {
          //   this.$refs.Personal.resetFields && this.$refs.Personal.resetFields()
          // }
          this.$refs.Personal.getPersonInfo(((data && data.length) ? params : null), this.readOnly)
        })
      })
    },
    //获取申报基础信息
    getDeclareBasicInfo (applicationObjectId = '') {
      this.recommendInfo.isCanel = null
      getApplication({applicationInfoId: this.applicationInfoId}).then(({data}) => {
        this.declareInfo = data
        if (this.declareInfo.applicationExplain) {
          this.declareInfo.applicationExplain = this.declareInfo.applicationExplain.replaceAll('\n', '<br />')
        }
        //获取申报附件
        if (data.applicationFileGroupId) {
          this.getActivityFiles(data.applicationFileGroupId).then(files => {
            this.$set(this.declareInfo, 'initalFile', files)
          })
        }
        //获取申报下面的奖项列表
        this.prizeList = data.applicationObjectList || []
        let firstPrize = this.prizeList[0]
        //todo 评审打分的时候  设置当前查看的奖项   需要跟后端对 如何确定是选择的哪个奖项  目前这种方式不对  
        // 评审打分时，不显示其他奖项-张蕾提出
        if (this.businessId) {
          const index = data.applicationObjectList.findIndex(val => val.applicationObjectId == applicationObjectId)
          this.currentIndex = index
          firstPrize = data.applicationObjectList[index] || ''
          this.prizeList = firstPrize ? [firstPrize] : []
        } else {
          this.prizeList = data.applicationObjectList || []
        }
        if (firstPrize) {
          this.currentPrize = firstPrize
          this.basicFormType = firstPrize.basicFormType
          this.prizeDesc = firstPrize.applicationExplain || ''
          this.applicationObjectId = firstPrize.applicationObjectId || ''
          this.dynamicFormId = firstPrize.dynamicFormId
          if (firstPrize.applicationFileGroupId) {
            this.getActivityFiles(firstPrize.applicationFileGroupId).then(files => {
              this.prizeFiles = files
            })
          }
          if (!this.businessId) {
            this.getCorreSignUpId()
          }
        }
      })
    },
    //选择奖项
    onSelectPrize (item, index) {
      this.isSee = false
      this.recommendInfo.isCanel = null
      //如果是评审打分过来的 应该只读
      if (this.businessId) return
      this.currentPrize = item
      this.currentIndex = index
      this.basicFormType = item.basicFormType
      this.prizeDesc = item.applicationExplain
      this.applicationObjectId = item.applicationObjectId
      this.dynamicFormId = item.dynamicFormId
      this.signUpId = ''
      this.getCorreSignUpId('check')
      if (item.applicationFileGroupId) {
        this.getActivityFiles(item.applicationFileGroupId).then(files => {
          this.prizeFiles = files
        })
      }
    },
    //获取文件信息
    getActivityFiles (groupId) {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-uum/file/listFilesByGroupId',
          method: 'GET',
          data: {
            isPage: false,
            groupId: groupId
          }
        }).then(({data}) => {
          resolve(data.data || [])
        })
      })
    },
    back () {
      if (this.backUrl == 'reviewGrade') {
        this.$router.go(-1)
      } else {
        this.$router.push({
          name: this.backUrl || 'appraisingList',
          query: {
            currentPage: this.$route.query.currentPage || 1,
            tabName: this.$route.query.tabName || '',
          }
        })
      }
    }
  },
  components: {
    FormLayout,
    Upload,
    Expand,
    IconFont,
    LayoutTitle,
    Personal,
    Team,
    Outside,
    QuickModal,
    Organization,
    Project,
    ScoreModal,
    FooterOperator
  }
}
</script>

<style lang="scss" scoped>
.iv-appra-declare-enroll {
  .iv-enroll-top {
    background: #F5F7FA;
    .iv-enroll-top-expand {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    .iv-enroll-top-description {
      display: flex;
    }
  }
  .iv-app-detail-fill {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .iv-enroll-content {
    background: #fff;
    .iv-enroll-content-ul {
      overflow: hidden;
      li {
        width: 282px;
        padding: 18px 26px;
        border-radius: 16px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        margin-right: 24px;
        &:nth-child(4n) {
          margin-right: 0;
        }
        &:hover {
          font-weight: bold;
          color: #FA2900 !important;
          border-color: #FA2900;
        }
        &.iv-enroll-active {
          font-weight: bold;
          color: #FA2900 !important;
          border-color: #FA2900;
        }
      }  
    }    
    .iv-enroll-content-desc {
      background-color: #F5F7FA;
      border-radius: 16px;
      padding: 20px 24px;
    }    
    .iv-enroll-content-selcect {
      color: #FA2900;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
      text-decoration: underline;
      font-weight: 400;
    }
    .iv-enroll-block {
      h3 {
        border-bottom: 1px solid rgba(0, 0, 0, 0.15);
      }
    }
  }
}
</style>
